
var installPromptEvent = null;
var isStandaloneMode = false;
var serviceWorkerAvailable = false;
var pwaContainer = null;
window.addEventListener("beforeinstallprompt", function(event) {
    event.preventDefault();
    installPromptEvent = event;

    if (serviceWorkerAvailable && !isStandaloneMode && pwaContainer && installPromptEvent !== null) {
        pwaContainer.removeClass('d-none');
    }
});

if ('serviceWorker' in navigator) {
    serviceWorkerAvailable = true;
    console.log("serviceWorker available");

    //This is the "Offline page" service worker
    //Add this below content to your HTML page, or add the js file to your page at the very top to register service worker
    if (navigator.serviceWorker.controller) {
        console.log('[PWA Builder] active service worker found, no need to register')
    } else {
        //Register the ServiceWorker
        navigator.serviceWorker.register('/pwabuilder-sw.js', {
            scope: '/'
        }).then(function(reg) {
            console.log('Service worker has been registered for scope:'+ reg.scope);
        });
    }
}

if (window.matchMedia('(display-mode: standalone)').matches) {
    isStandaloneMode = true;
    console.log("This is running as standalone.");
}

function askPwaInstall() {
    if (installPromptEvent !== null) {
        installPromptEvent.prompt();
        installPromptEvent.userChoice
            .then(function(choiceResult){
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');
                } else {
                    console.log('User dismissed the A2HS prompt');
                }
                installPromptEvent = null;
            });
    }
}

$(document).ready(function() {
    pwaContainer = $('.pwa-container');
    $('#pwaInstaller').click(function() {
        askPwaInstall();
    });
});
